export default __webpack_public_path__ + "static/minnesota-furnace-repair-5f06fca0f4e55a4c70073e38a99fdbaa.jpg";